/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchScheduleStartScheduled = {
  Scheduled: "scheduled",
} as const;
export type KillswitchScheduleStartScheduled = ClosedEnum<
  typeof KillswitchScheduleStartScheduled
>;

/** @internal */
export const KillswitchScheduleStartScheduled$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleStartScheduled
> = z.enum(KillswitchScheduleStartScheduled);
/** @internal */
export const KillswitchScheduleStartScheduled$outboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleStartScheduled
> = KillswitchScheduleStartScheduled$inboundSchema;
